import gsap from 'gsap';
import { SplitText } from '../libs/splitText';

const splitText = (text) => {

    var split = new SplitText(text, {type: "lines"});
    
    const tl = gsap.timeline({
        defaults: {
            duration: .6, ease: "circ.out", stagger: .05, delay: .3,
        }
    })
    
    tl
    .fromTo(split.lines, { opacity: 0, yPercent: '101' }, { opacity: 1, yPercent: '0', clearProps:"all" }, 0)

    // Función para adaptar el texto al cambio de tamaño de pantalla
    // const resizeText = (text) => {
    //     // Limpiar la animación actual y revertir el texto dividido
    //     tl.progress(0).clear();
    //     split.revert();

    //     // Crear una nueva animación con el texto adaptado al nuevo tamaño de pantalla
    //     var split = new SplitText(text, {type: "lines"});
    //     const tl = gsap.timeline({
    //         defaults: {
    //             duration: .6, ease: "circ.out", stagger: .05, delay: .3,
    //         }
    //     })
    //     tl.fromTo(split.lines, { opacity: 0, yPercent: '101' }, { opacity: 1, yPercent: '0', clearProps: "all" }, 0);
    // };

    // Agregar el evento de cambio de tamaño de pantalla
    // window.addEventListener("resize", resizeText(text));
    
    return tl
}

export default splitText;